var ConsumerFinancesAjax = (function () {
    // OOD Main/Landing Page
    async function getAccountTransectionEntriesAsync(
        consumerIds,
        activityStartDate,
        activityEndDate,
        accountName,
        payee,
        category,
        minamount,
        maxamount,
        checkNo,
        balance,
        enteredBy,
        isattachment,
        transectionType,
        accountPermission,
    ) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAccountTransectionEntries/',
                data:
                    '{"token":"' +
                    $.session.Token +
                    '", "consumerIds":"' +
                    consumerIds +
                    '", "activityStartDate":"' +
                    activityStartDate +
                    '", "activityEndDate":"' +
                    activityEndDate +
                    '", "accountName":"' +
                    accountName +
                    '", "payee":"' +
                    payee +
                    '", "category":"' +
                    category +
                    '", "minamount":"' +
                    minamount +
                    '", "maxamount":"' +
                    maxamount +
                    '", "checkNo":"' +
                    checkNo +
                    '", "balance":"' +
                    balance +
                    '", "enteredBy":"' +
                    enteredBy +
                    '", "isattachment":"' +
                    isattachment +
                    '", "transectionType":"' +
                    transectionType +
                    '", "accountPermission":"' +
                    accountPermission +
                    '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getActiveAccountAsync(ConsumersId, accountPermission) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getActiveAccount/',
                data: JSON.stringify({
                    token: $.session.Token,
                    consumerId: ConsumersId,
                    accountPermission: accountPermission,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getPayeesAsync(ConsumersId) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getPayees/',
                data: JSON.stringify({
                    token: $.session.Token,
                    consumerId: ConsumersId,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getCategoriesAsync(CategoryID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getCatogories/',
                data: JSON.stringify({
                    token: $.session.Token,
                    categoryID: CategoryID,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getSubCategoriesAsync(Category) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getSubCatogories/',
                data: JSON.stringify({
                    token: $.session.Token,
                    category: Category,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getCategoriesSubCategoriesByPayeeAsync(CategoryID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getCategoriesSubCategoriesByPayee/',
                data: JSON.stringify({
                    token: $.session.Token,
                    categoryID: CategoryID,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function insertPayeeAsync(payeeName, payeeaddress1, payeeaddress2, payeecity, payeestate, payeezipcode) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/insertPayee/',
                data: JSON.stringify({
                    token: $.session.Token,
                    payeeName: payeeName,
                    address1: payeeaddress1,
                    address2: payeeaddress2,
                    city: payeecity,
                    state: payeestate,
                    zipcode: payeezipcode,
                    userId: $.session.UserId,
                    consumerId: $.session.consumerId,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function insertAccountAsync(
        date,
        amount,
        amountType,
        AccountID,
        payee,
        CategoryID,
        subCategory,
        checkNo,
        description,
        attachmentID,
        attachmentDesc,
        receipt,
        BtnName,
        regId,
        splitAmount,
        categoryID,
        consumerID
    ) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/insertAccount/',
                data: JSON.stringify({
                    token: $.session.Token,
                    date: date,
                    amount: amount,
                    amountType: amountType,
                    account: AccountID,
                    payee: payee,
                    category: CategoryID,
                    subCategory: subCategory,
                    checkNo: checkNo,
                    description: description,
                    attachmentId: attachmentID,
                    attachmentDesc: attachmentDesc,
                    receipt: receipt,
                    userId: $.session.UserId,
                    eventType: BtnName,
                    regId: regId,
                    splitAmount: splitAmount,
                    categoryID: categoryID,
                    consumerId: consumerID
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getAccountEntriesByIDAsync(registerId) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAccountEntriesById/',
                data: '{"token":"' + $.session.Token + '", "registerId":"' + registerId + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function deleteConsumerFinanceAccountAsync(registerId) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/deleteConsumerFinanceAccount/',
                data: '{"token":"' + $.session.Token + '", "registerId":"' + registerId + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getActiveEmployeesAsync() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getActiveUsedBy/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function addCFAttachment(retrieveData) {
        try {
            var binary = '';
            var bytes = new Uint8Array(retrieveData.attachment);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            let abString = window.btoa(binary);
            retrieveData.attachment = abString;
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/addCFAttachment/',
                data: JSON.stringify(retrieveData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return data.addCFAttachmentResult;
        } catch (error) {
            console.log(error.responseText);
        }
    }

    function deleteCFAttachment(attachmentId) {
        data = {
            token: $.session.Token,
            attachmentId: attachmentId,
        };
        try {
            $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/deleteCFAttachment/',
                data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (response, status, xhr) {
                    var res = response.deletePlanAttachmentResult;
                },
            });
        } catch (error) {
            console.log(error.responseText);
        }
    }

    async function getCFAttachmentsList(retrieveData) {
        try {
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getCFAttachmentsList/',
                data: JSON.stringify(retrieveData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return data.getCFAttachmentsListResult;
        } catch (error) {
            console.log(error.responseText);
        }
    }

    async function getConsumerNameByID(retrieveData) {
        //token, consumerId
        return $.ajax({
            type: 'POST',
            url:
                $.webServer.protocol +
                '://' +
                $.webServer.address +
                ':' +
                $.webServer.port +
                '/' +
                $.webServer.serviceName +
                '/getConsumerNameByID/',
            data: JSON.stringify(retrieveData),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        });
    }

    function viewCFAttachment(attachmentId, section) {
        $.ajax({
            type: 'POST',
            url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/viewCFAttachment/',
            data: '{"token":"' + $.session.Token + '", "attachmentId":"' + attachmentId + '", "section":"' + section + '"}',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response, status, xhr) {
                var fileType;
                var arr = response.viewCFAttachmentResult.data._buffer;
                var byteArray = new Uint8Array(arr);
                const ext = response.viewCFAttachmentResult.filetype;
                fileType = UTIL.MIMEType(ext);
                var blob = new Blob([byteArray], { type: fileType });
                if ($.session.browser == 'Explorer' || $.session.browser == 'Mozilla') {
                    window.navigator.msSaveOrOpenBlob(blob, 'report.pdf');
                } else {
                    var fileURL = URL.createObjectURL(blob);
                    window.open(fileURL);
                }
                reports.handledProcessedReport();
            }
        });
    }

    async function getCategoriesSubCategoriesAsync(CategoryID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getCategoriesSubCategories/',
                data: JSON.stringify({
                    token: $.session.Token,
                    categoryID: CategoryID,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getEditAccountInfoByIdAsync(accountId) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getEditAccountInfoById/',
                data: '{"token":"' + $.session.Token + '", "accountId":"' + accountId + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getAccountClassAsync() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAccountClass/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function insertEditRegisterAccountAsync(
        selectedConsumersId,
        accountId,
        name,
        number,
        type,
        status,
        classofAccount,
        dateOpened,
        dateClosed,
        openingBalance,
        description,
    ) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/insertEditRegisterAccount/',
                data: JSON.stringify({
                    token: $.session.Token,
                    selectedConsumersId: selectedConsumersId,
                    accountId: accountId,
                    name: name,
                    number: number,
                    type: type,
                    status: status,
                    classofAccount: classofAccount,
                    dateOpened: dateOpened,
                    dateClosed: dateClosed,
                    openingBalance: openingBalance,
                    description: description,
                    userId: $.session.UserId,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getEditAccountAsync(ConsumersId, accountPermission) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getEditAccount/',
                data: JSON.stringify({
                    token: $.session.Token,
                    consumerId: ConsumersId,
                    accountPermission: accountPermission,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getSplitRegisterAccountEntriesByIDAsync(registerId) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getSplitRegisterAccountEntriesByID/',
                data: '{"token":"' + $.session.Token + '", "registerId":"' + registerId + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getSplitCategoriesSubCategoriesAsync(CategoryID) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getSplitCategoriesSubCategories/',
                data: JSON.stringify({
                    token: $.session.Token,
                    categoryID: CategoryID,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getCategoryPageData(retrieveData) {
        try {
            const data = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getCategoryPageData/',
                data: JSON.stringify(retrieveData),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return data.getCategoryPageDataResult;
        } catch (error) {
            console.log(error.responseText);
        }
    }

    async function getCategoryDropDownOfFilter() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getCategoryDropDownOfFilter/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getcategoryCodeDropDownOfFilter() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getcategoryCodeDropDownOfFilter/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getcategoryRapDropDownOfFilter() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getcategoryRapDropDownOfFilter/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getsubCategoryDropDownOfFilter() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getsubCategoryDropDownOfFilter/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getsubCategoryCodeDropDownOfFilter() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getsubCategoryCodeDropDownOfFilter/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function insertUpdateCategory(categoryId, category, type, code, repPayee) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/insertUpdateCategory/',
                data: JSON.stringify({
                    token: $.session.Token,
                    categoryId: categoryId,
                    category: category,
                    type: type,
                    code: code,
                    repPayee: repPayee,                   
                    userId: $.session.UserId,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function insertUpdateSubCategory(categoryId, category, code, subCategory) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/insertUpdateSubCategory/',
                data: JSON.stringify({
                    token: $.session.Token,
                    categoryId: categoryId,
                    category: category,
                    code: code,
                    subCategory: subCategory,
                    userId: $.session.UserId,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getAccountAttachments(accountId, isActive) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAccountAttachments/',
                data: '{"token":"' + $.session.Token + '","accountId":"' + accountId + '","isActive":"' + isActive + '"}',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function getAttachmentCategory() {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/getAttachmentCategory/',
                data: JSON.stringify({
                    token: $.session.Token,
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    function viewAccountAttachment(attachmentId) {
        $.ajax({ 
            type: 'POST',
            url: $.webServer.protocol + '://' + $.webServer.address + ':' + $.webServer.port + '/' + $.webServer.serviceName + '/viewAccountAttachment/',
            data: '{"token":"' + $.session.Token + '", "attachmentId":"' + attachmentId + '"}',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response, status, xhr) {
                var fileType;
                var arr = response.viewAccountAttachmentResult.data._buffer;
                var byteArray = new Uint8Array(arr);
                const ext = response.viewAccountAttachmentResult.filetype;
                fileType = UTIL.MIMEType(ext);
                var blob = new Blob([byteArray], { type: fileType }); 
                if ($.session.browser == 'Explorer' || $.session.browser == 'Mozilla') {
                    window.navigator.msSaveOrOpenBlob(blob, 'report.pdf');
                } else {
                    var fileURL = URL.createObjectURL(blob);
                    window.open(fileURL);
                }
                reports.handledProcessedReport();
            }
        });
    }

    async function insertUpdateAccountAttachment(updatedAttachmentList, deletedAttachmentList, newAttachmentList, accountId, selectedConsumersId) {
        try {
            const result = await $.ajax({
                type: 'POST',
                url:
                    $.webServer.protocol +
                    '://' +
                    $.webServer.address +
                    ':' +
                    $.webServer.port +
                    '/' +
                    $.webServer.serviceName +
                    '/insertUpdateAccountAttachment/',
                data: JSON.stringify({
                    token: $.session.Token,
                    userId: $.session.UserId,
                    updatedAttachmentList: updatedAttachmentList,
                    deletedAttachmentList: deletedAttachmentList,
                    newAttachmentList: newAttachmentList,
                    accountId: accountId,
                    consumerId: selectedConsumersId
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
            });
            return result;
        } catch (error) {
            throw new Error(error.responseText);
        }
    }

    async function convertBinaryToString(attachment) {
        try {           
            var binary = '';
            var bytes = new Uint8Array(attachment);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            
            let abString = window.btoa(binary);           
            return abString;
        } catch (error) {
            console.log(error.responseText);
        }
    }


    return {
        getAccountTransectionEntriesAsync,
        getActiveAccountAsync,
        getPayeesAsync,
        getCategoriesAsync,
        getSubCategoriesAsync,
        getCategoriesSubCategoriesByPayeeAsync,
        insertPayeeAsync,
        insertAccountAsync,
        getAccountEntriesByIDAsync,
        deleteConsumerFinanceAccountAsync,
        getActiveEmployeesAsync,
        addCFAttachment,
        deleteCFAttachment,
        getCFAttachmentsList,
        getConsumerNameByID,
        viewCFAttachment,
        getCategoriesSubCategoriesAsync,
        getEditAccountInfoByIdAsync,
        getAccountClassAsync,
        insertEditRegisterAccountAsync,
        getEditAccountAsync,
        getSplitRegisterAccountEntriesByIDAsync,
        getSplitCategoriesSubCategoriesAsync,
        getCategoryPageData,
        getCategoryDropDownOfFilter,
        getcategoryCodeDropDownOfFilter,
        getcategoryRapDropDownOfFilter,
        getsubCategoryDropDownOfFilter,
        getsubCategoryCodeDropDownOfFilter,
        insertUpdateCategory,
        insertUpdateSubCategory,
        getAccountAttachments,
        getAttachmentCategory,
        viewAccountAttachment,
        insertUpdateAccountAttachment,
        convertBinaryToString
    };
})();
